"use strict";
// This banner appears on the Growth Suite Calculator when the Covid Promotion is active
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _SuiteCovidPromoBanner = _interopRequireDefault(require("../growth-suite-page/SuiteCovidPromoBanner"));

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _Hubs = require("self-service-api/constants/Hubs");

var _LoadingStateSelectors = require("../../selectors/LoadingStateSelectors");

var _Editions = require("self-service-api/constants/Editions");

var _Terms = require("self-service-api/constants/Terms");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var CalcCovidPromoBannerContainer = function CalcCovidPromoBannerContainer(_ref) {
  var isCovidGrowthSuitePromoEligible = _ref.isCovidGrowthSuitePromoEligible,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      currencyCode = _ref.currencyCode,
      calculateBundlePrice = _ref.calculateBundlePrice;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);

  if (!isCovidGrowthSuitePromoEligible || !hasPricingAndPurchasingSucceeded) {
    return null;
  }

  var pricingInfoParams = {
    bundleSelections: {
      marketingPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[_Editions.STARTER][_Hubs.HUB_MARKETING],
      salesPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[_Editions.STARTER][_Hubs.HUB_SALES],
      servicePlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[_Editions.STARTER][_Hubs.HUB_SERVICE]
    },
    term: _Terms.MONTHLY,
    isGrowthSuite: true
  };
  var pricingInfo = calculateBundlePrice((0, _extends2.default)({}, pricingInfoParams, {
    isCovidPromo: isCovidGrowthSuitePromoEligible
  }));
  var originalDiscountedPrice = calculateBundlePrice(pricingInfoParams).monthly.calculatedPrice;
  return _react.default.createElement(_SuiteCovidPromoBanner.default, {
    toPrice: pricingInfo.monthly.calculatedPrice,
    fromPrice: originalDiscountedPrice,
    currencyCode: currencyCode,
    width: "970px"
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    calculateBundlePrice: (0, _PricingSelectors.getCalculateBundlePriceSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(CalcCovidPromoBannerContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/CalcCovidPromoBannerContainer.js
// module id = 801
// module chunks = 5 6